// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infobox-wrapper .infobox.small-infobox {
  background-color: #faf7f3;
  border-radius: 30px;
  padding: 12px;
}
.infobox-wrapper .infobox.big-infobox {
  color: var(--plus-color-purple-90);
  background-color: var(--plus-color-primary);
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  padding: 30px;
  border: 1px solid var(--plus-color-purple-90);
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/InfoBox/InfoBox.scss"],"names":[],"mappings":"AAEE;EACC,yBAAA;EACA,mBAAA;EACA,aAAA;AADH;AAGE;EACC,kCAAA;EACA,2CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,6CAAA;EACA,kBAAA;AADH","sourcesContent":[".infobox-wrapper {\n\t.infobox {\n\t\t&.small-infobox {\n\t\t\tbackground-color: #faf7f3;\n\t\t\tborder-radius: 30px;\n\t\t\tpadding: 12px;\n\t\t}\n\t\t&.big-infobox {\n\t\t\tcolor: var(--plus-color-purple-90);\n\t\t\tbackground-color: var(--plus-color-primary);\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 22px;\n\t\t\ttext-align: left;\n\t\t\tpadding: 30px;\n\t\t\tborder: 1px solid var(--plus-color-purple-90);\n\t\t\tborder-radius: 3px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
